import useEditShopContext from 'contexts/shop.context';
import React from 'react';

const PreviewShopImages = () => {
  const { shopDetails } = useEditShopContext();

  const details = [
    { value: shopDetails?.images?.[0], label: 'Image 1' },
    { value: shopDetails?.logo, label: 'Image 2' }
  ];
  return (
    <div className='space-y-6'>
      {details.map((detail) => (
        <div
          key={detail.label}
          className='border border-gray-1 rounded-lg pl-3 flex items-center mb-4'>
          <h2 className='text-sm   text-gray-5 w-40'>{detail.label}</h2>
          {detail.value ? (
            <img
              src={detail.value}
              alt='Shop images'
              className='w-full object-cover h-40 rounded-lg'
            />
          ) : (
            <span className='p-3.5'>N/A</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default PreviewShopImages;
